import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Input, Popover, Button, Modal } from '@bedrock/components'
import {useClickAway} from 'ahooks'
import cx from 'classnames'
import './index.less'
import TextAreaShow from '../TextAreaShow/index'


//自定义受控组件
type TextAreaPopconfirmProps = {
    view?: boolean
    value?: string
    onChange?: (value: string) => void
    showLine?: number
    linkDetector?: boolean;
    wrapperClassName?: string
    wrapperStyle?: React.CSSProperties
    renderChildren?: (value: string) => React.ReactElement
    textAreaProps?: React.ComponentProps<typeof Input.TextArea>
} & React.ComponentProps<typeof Popover>

export default function TextAreaPopover({
    value,
    onChange,
    renderChildren,
    showLine = 2,
    linkDetector,
    view = false,
    wrapperClassName,
    wrapperStyle,
    title,
    textAreaProps,
    ...otherProps
}: TextAreaPopconfirmProps) {
    const [visible, setVisible] = useState(false)
    const [content, setContent] = useState(value)
    useEffect(() => {
        setContent(value)
    }, [value])
    const inputRef = useRef(null)
    const contentRef = useRef(null)
    const childrenRef = useRef(null)
    useClickAway(() => {
        setVisible(false)
    }, contentRef)
    const children = renderChildren ? renderChildren(value) : <Input value={value}/>
    
    useEffect(() => {
        if (visible) {
            setContent(value)
            setTimeout(() => {
                inputRef.current?.focus()
            }, 100)
        }
    }, [visible])

    if (view) {
        return <div className={cx('sform-textarea-propover', wrapperClassName)} style={wrapperStyle}>
            {!value ? '--' : <TextAreaShow value={value} showLine={showLine} showTooltip={true} linkDetector={linkDetector} />}
        </div>
    }


    return <div className={cx('sform-textarea-propover', wrapperClassName)} style={wrapperStyle}>
        <Popover
            visible={visible}
            showArrow={false}
            destroyTooltipOnHide
            placement="bottomLeft"
            {...otherProps}
            title={null}
            content={
                <div className="sform-textarea-propover-content" ref={contentRef}>
                    {title && <div className="sform-textarea-propover-content-title">{title}</div>}
                    <Input.TextArea
                        ref={inputRef}
                        autoSize={true}
                        block={true}
                        rows={4}
                        maxLength={500}
                        showCount={true}
                        focusCaret="end"
                        maxHeight={280}
                        {...textAreaProps}
                        value={content}
                        onChange={(e) => {
                            setContent(e.target.value)
                        }}
                    />
                    <div className="sform-textarea-propover-content-footer">
                        <Button type="default" onClick={() => {
                            setContent('')
                        }}>重置</Button>
                        <Button type="primary" onClick={() => {
                            onChange?.(content)
                            setVisible(false)
                        }}>确定</Button>
                    </div>
                </div>
            }
        >
           {
            React.cloneElement(children as React.ReactElement, {
                ref: childrenRef,
                onClick: (e) => {
                    e.stopPropagation()
                    setVisible(true)
                    visible && inputRef.current?.focus?.()
                }
            })
           }
        </Popover>
    </div>
}
